module.exports = __webpack_public_path__ + "static/media/DSC09732.71720bbb.jpg";